import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';

import {ApiService} from '../shared/api-service.service'

import {Router} from '@angular/router';

import { FormGroup, FormControl } from '@angular/forms';
import { Validators } from '@angular/forms';

@Component({
  selector: 'app-authorize-net-page',
  templateUrl: './authorize-net-page.component.html',
  styleUrls: ['./authorize-net-page.component.css']
})
export class AuthorizeNetPageComponent implements OnInit {

  leadData:any = {}
  clientSideKey:String = "AbGoAPD1b2IbNO1DzUveYJ0GkulMjcPoLaIiWXsKT0l69WeMh9UIgfgXUQzCnHPvc7Mzn3DDAqTFcLTl"
  userFirstName:String = ""
  details:String = ""
  feedBack:String = ""

  @ViewChild('firstNameLabel',{static:true}) private firstNameLabel;
  @ViewChild('paypal',{static:true})  paypalRef : ElementRef;

  authForm = new FormGroup({
    cardNumber: new FormControl('',Validators.required),
    expDate: new FormControl('',Validators.required),
    cvc: new FormControl('',Validators.required),
  });

  product = {
    price: 25,
    desription: "application fee",
  }

  paidFor:boolean = true
  wasError:boolean = false
  constructor( private router: Router, private cloudService: ApiService ) { }

  ngOnInit() {
    this.loadUserData()
  }

  loadUserData(){
    this.leadData = JSON.parse(localStorage.getItem("leadData"))
   
    console.log(this.leadData)
    this.userFirstName = this.leadData.first_name
    if(this.leadData.maritalStatus == "married"){
      this.product = {
        price: 50,
        desription: "application fee",
      }
    }
    this.formatDetailsStr()
  }

  formatDetailsStr(){
    if(this.leadData.maritalStatus == "married"){
      this.details = "As a married applicant, your review is estimated at $50."
    }else if(this.leadData.maritalStatus == "unmarried"){
      this.details = "As an unmarried applicant, your review is estimated at $25."
    }else{
      this.details = "As a seperated applicant, your review is estimated at $25."
    }
  }

  confimration(){
    console.log("should have routed");
   
    this.cloudService.cloudPost(JSON.stringify(this.leadData)).subscribe(packet => {
      console.log("packet?" + packet)
    });
    console.log("called post")
    this.router.navigate(['confirmation']);
  }

  authNetCall(cardData:any){
    this.cloudService.authNetPost(this.leadData, cardData, String(this.product.price)).subscribe(packet =>{
      let packet2 = JSON.parse(JSON.stringify(packet))
      console.log("payment response")
      console.log(JSON.stringify(packet2))
      console.log(packet2)
      packet
      if(packet2.transactionResponse.responseCode == "1"){
        this.leadData.paid = "true"
        this.feedBack = "One moment.."
        this.cloudService.cloudPost(JSON.stringify(this.leadData)).subscribe(packet => {
          console.log("packet?" + packet)
          this.router.navigate(['confirmation']);
        });
      }else{
        console.log("payment rejected on " + packet2.transactionResponse.responseCode)
        this.feedBack = "There was a problem processing your payment. Please double check your info and try again."
      }
    })
  }

  payNow(){
    console.log("validating payment..")
    this.feedBack = " "
    var cardNumber = this.authForm.get('cardNumber').value
    //clean spaces out of the string
    cardNumber = cardNumber.split(" ").join("")
    var expirationDate = this.authForm.get('expDate').value
    var cardCode = this.authForm.get('cvc').value
    var myJson = {
      "cardNumber":cardNumber,
      "expirationDate":expirationDate,
      "cardCode":cardCode,
    }
    if(this.validateCardNumber(cardNumber) == false){
      this.feedBack = "Please Enter Your Card Number With Numbers and Spaces Only"
    }else if(this.validateExpDate(expirationDate) == false){
      this.feedBack = "Please enter the expiration date as (YYYY-MM)"
    }else if(this.validateCVC(cardCode) == false){
      this.feedBack = "Oops.. check your cvc"
    }else{
      this.feedBack = "Payment Submitted"
      this.authNetCall(myJson)
    }
  }

  validateCardNumber(card:string){
    if(card.length < 9){
      return false
    }else{
      for(var i = 0; i < card.length; i++){
        let curNum = card[i]
        if(this.charIsNum(curNum) == false){
          return false
        }
      }
      return true
    }
  }

  validateExpDate(expDate:string){
    if(expDate.length != 7){
      console.log("other failed")
      return false
    }else{
      for(var i = 0; i < expDate.length; i++){
        let cur = expDate[i];
        if(i == 4 && cur != "-"){
          console.log("- failed?")
          return false
        }else if(this.charIsNum(cur) == false){
          if(i != 4){
            return false
          }
        }
      }
      return true
    }
  }

  validateCVC(cvc:String){
    if(cvc.length < 3){
      return false
    }else{
      for(var i = 0; i < cvc.length; i++){
        let cur = cvc[i]
        if(this.charIsNum(cur) == false){
          return false
        }
      }
      return true
    }
  }

  charIsNum(inStr:string){
    for(let char of inStr){
      if(char == '1'){
        return true;
      }else if(char == '2'){
        return true;
      }else if(char == '3'){
        return true;
      }else if(char == '4'){
        return true;
      }
      else if(char == '5'){
        return true;
      }else if(char == '6'){
        return true;
      }else if(char == '7'){
        return true;
      }else if(char == '8'){
        return true;
      }else if(char == '9'){
        return true;
      }else if(char == '0'){
        return true;
      }
    }
    return false;
  }
}